export const PARTNERS_LIST_VIEW = "/partners"
export const PARTNER_TRACTOARE_RO_VIEW = PARTNERS_LIST_VIEW + "/tractoare-ro/"
